export const inActiveTimerOptions = {
  timeout: 10 * 60 * 1000,
  syncTimers: 200,
  throttle: 500
};
